import { ApiProperty } from '@nestjs/swagger';

export class AuthenticatedUserResponse {
  @ApiProperty({
    type: String,
    example:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjI2LCJlbWFpbCI6InRlc3p0LmVsZWsxQGdtYWlsLmNvbSIsImZpcnN0TmFtZSI6IkVsZWsiLCJsYXN0TmFtZSI6IlRlc3p0IiwicGhvbmUiOiIrMzYzMDI3NDQ5OTgiLCJ0eXBlIjoiSURfVE9LRU4iLCJpYXQiOjE2MjM1MzA1MzZ9.JbvXvsyZxQloMF-B2odLmZpE3a6GwRY9aAE6Ig2aasw',
  })
  idToken: string;

  @ApiProperty({
    type: String,
    example:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIyNiIsInR5cGUiOiJBQ0NFU1NfVE9LRU4iLCJpYXQiOjE2MjM1MzA1MzZ9.BM0JKOvfT6-kAmmFOTBp73RJI1eNXcAe2jpi2BCa8zo',
  })
  accessToken: string;

  constructor({ idToken, accessToken }: AuthenticatedUserResponse) {
    this.idToken = idToken;
    this.accessToken = accessToken;
  }
}
